import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

type ShareTitleTooltipTextProps = {
  titleNumber?: number;
  encumbranceNumber?: number;
};

export const ShareTitleTooltipText: FC<ShareTitleTooltipTextProps> = ({
  titleNumber,
}) => {
  const { t } = useTranslate();

  return titleNumber ? (
    <span>
      <span className="fw-bold text-decoration-underline">
        {t('Title')} #{titleNumber}
      </span>
      <br />
      <span>{t('SharesTitleOnlyPartner')}</span>
    </span>
  ) : (
    <span>{t('SharesTitleOnlyPartner')}</span>
  );
};

export const ShareTitleTooltipTextWithCoOwners: FC<
  ShareTitleTooltipTextProps
> = ({ encumbranceNumber }) => {
  const { t } = useTranslate();

  return encumbranceNumber ? (
    <span className="d-block text-center ">
      <span className="fw-bold text-decoration-underline">
        {t('Title')} #{encumbranceNumber}
      </span>
      <br />
      <span>{t('SharesTitleWithCoOwners')}</span>
    </span>
  ) : (
    <span>{t('SharesTitleWithCoOwners')}</span>
  );
};
